import Cropper from 'cropperjs';

export default class Crop {
  constructor(self, image, config) {
    this.self = self;
    this.config = config;
    this.image = image;
    this.cropper = undefined;

    this.jcrop = {
      JcropH: [],
      JcropW: [],
      JcropY: [],
      JcropX: [],
    };
  }

  trigger() {
    const self = this.self;

    const config = {
      aspectRatio: this.self.ratio,
      viewMode: 1,
      background: false,
      modal: false,
      crop(event) {
        self.jcrop.JcropX.splice(0, 1, event.detail.x);
        self.jcrop.JcropY.splice(0, 1, event.detail.y);
        self.jcrop.JcropW.splice(0, 1, event.detail.width);
        self.jcrop.JcropH.splice(0, 1, event.detail.height);
      },
    };

    this.cropper = new Cropper(this.image, config);
    this.self.display.crop = true;
    this.self.display.image = false;
    this.self.display.unloadButton = false;
  }

  fireEvent(event) {}

  cancel() {
    this.cropper.destroy();
    this.self.display.crop = false;
    this.self.display.cropButton = true;
    this.self.display.unloadButton = true;
    this.self.display.image = true;
  }

  validate() {
    this.self.display.image = true;
    const canvas = this.cropper.getCroppedCanvas();
    this.self.newImage.preview = canvas.toDataURL('image/jpeg');
    this.cropper.destroy();
  }
}
